import {
  FormativeCheckSVG,
  PowerWordFilledSVG,
  type SvgComponentType,
} from "@newsela/angelou";

export enum InstructionFeatureValuesEnum {
  power_words = "power_words",
  has_formative = "has_formative",
}

export interface IInstructionalFeatureOption {
  label: string;
  value: InstructionFeatureValuesEnum;
  dataQaSelector: string;
  SvgComponent: SvgComponentType;
}

export const INSTRUCTIONAL_FEATURE_POWER_WORDS_OPTION: IInstructionalFeatureOption =
  {
    label: "Power Words",
    value: InstructionFeatureValuesEnum.power_words,
    dataQaSelector: "filter-search-by-power-words-instructional-feature",
    SvgComponent: PowerWordFilledSVG as SvgComponentType,
  };

export const INSTRUCTIONAL_FEATURE_FORMATIVE_OPTION: IInstructionalFeatureOption =
  {
    label: "Formatives by Newsela",
    value: InstructionFeatureValuesEnum.has_formative,
    dataQaSelector: "filter-search-by-formative-instructional-feature",
    SvgComponent: FormativeCheckSVG as SvgComponentType,
  };

export const INSTRUCTIONAL_FEATURE_OPTIONS: IInstructionalFeatureOption[] = [
  INSTRUCTIONAL_FEATURE_POWER_WORDS_OPTION,
  INSTRUCTIONAL_FEATURE_FORMATIVE_OPTION,
];
